import { Box, Divider, styled } from '@mui/material';
import { WorkFormDetails } from 'shared/components/work-forms/details/work-form-details';
import { FormMode } from 'shared/components/shift-forms/components/forms/shared/types';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui';
import { useFormContext } from 'react-hook-form';
import { useGetCompanyEmploymentTypes, useGetWorkCreateData, useGetWorkTemplates } from 'api';
import { useSiteDetection } from 'shared/hooks';
import { DetailsForWorkTemplate } from 'shared/components/work-forms/details/work-form-details.types';
import { ProjectFormInputs } from './project-form-inputs';

export type ProjectFormProps = {
  mode: FormMode;
  isProjectWithActivePlacement: boolean;
  workDetails: DetailsForWorkTemplate | undefined;
};

export const ProjectForm = ({
  mode,
  isProjectWithActivePlacement,
  workDetails,
}: ProjectFormProps) => {
  const { watch } = useFormContext();
  const { site } = useSiteDetection();
  const company = watch('companyOption');
  const selectedCompanyId = company?.value;

  const workCreateDataQuery = useGetWorkCreateData(
    site,
    site === 'hq' ? selectedCompanyId : undefined,
    site === 'hq' ? !!selectedCompanyId : true
  );
  const employmentTypeOfCompanyQuery = useGetCompanyEmploymentTypes(
    site,
    site === 'hq' ? selectedCompanyId : undefined,
    site === 'hq' ? !!selectedCompanyId : true
  );
  const workTemplatesQuery = useGetWorkTemplates(
    site,
    site === 'hq' ? selectedCompanyId : undefined,
    site === 'hq' ? !!selectedCompanyId : true
  );

  if (employmentTypeOfCompanyQuery.status !== 'success') {
    return <RenderUnsettledUI data={employmentTypeOfCompanyQuery} />;
  }

  if (workCreateDataQuery.status !== 'success') {
    return <RenderUnsettledUI data={workCreateDataQuery} />;
  }

  if (workTemplatesQuery.status !== 'success') {
    return <RenderUnsettledUI data={workTemplatesQuery} />;
  }

  return (
    <Box display="flex" flexDirection="row">
      <Box display="flex" flexDirection="row" height="100%" flex="1">
        <ProjectFormInputs
          branchOfficesWithDepartments={workCreateDataQuery.data.branchOfficesWithDepartments}
          jobsData={workTemplatesQuery.data}
          mode={mode}
          isProjectWithActivePlacement={isProjectWithActivePlacement}
          companyEmploymentType={employmentTypeOfCompanyQuery.data}
          isDisabled={false}
        />
      </Box>
      <Box>
        <StyledDivider />
      </Box>
      <Box flex="1" display="flex">
        <WorkFormDetails workDetails={workDetails} />
      </Box>
    </Box>
  );
};

const StyledDivider = styled(Divider)(({ theme }) => ({
  height: '100%',
  marginLeft: theme.spacing(7),
  width: 2,
}));
